import { ProviderBadge } from '@/components/ProviderBadge';
import { Button } from '@/components/ui/button';
import { SheetFooter } from '@/components/ui/sheet';
import type { ProfileFormApi } from './useProfileForm';

/** The picked account's badge on the left; Cancel and Save/Create on the right. */
export function ProfileFooter({ form, onDone }: { form: ProfileFormApi; onDone: () => void }) {
  return (
    <SheetFooter className="flex-row items-center justify-between border-t">
      {form.account ? <ProviderBadge kind={form.account.kind} /> : <span />}
      <span className="flex gap-2">
        <Button type="button" variant="ghost" onClick={onDone}>
          Cancel
        </Button>
        <Button type="submit" data-testid="profile-submit" loading={form.pending}>
          {form.edit ? 'Save profile' : 'Create profile'}
        </Button>
      </span>
    </SheetFooter>
  );
}
